import SQLStorage from '../../SQLStorage';
import Utilities from '../../Utilities';
import Storage from '../../Storage';

const UpdatedSets = (state = [], action) => {

    switch(action.type) {

        case "PUSH":
            // @ts-ignore
            return  [...new Set(state.concat(action.data))]

        case "CLEAR_UPDATED_SETS":
            return [];

        default:
            return state;

    }

}

export default UpdatedSets;
